"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.includesNode = void 0;
var IRApp_1 = require("../../IRNodes/IRApp.js");
var IRDelayed_1 = require("../../IRNodes/IRDelayed.js");
var IRForced_1 = require("../../IRNodes/IRForced.js");
var IRFunc_1 = require("../../IRNodes/IRFunc.js");
var IRHoisted_1 = require("../../IRNodes/IRHoisted.js");
var IRLetted_1 = require("../../IRNodes/IRLetted.js");
function includesNode(parent, predicate) {
    var stack = [parent];
    while (stack.length > 0) {
        var t = stack.pop();
        if (predicate(t))
            return true;
        if (t instanceof IRLetted_1.IRLetted) {
            stack.push(t.value);
            continue;
        }
        if (t instanceof IRApp_1.IRApp) {
            stack.push(t.fn, t.arg);
            continue;
        }
        if (t instanceof IRDelayed_1.IRDelayed) {
            stack.push(t.delayed);
            continue;
        }
        if (t instanceof IRForced_1.IRForced) {
            stack.push(t.forced);
            continue;
        }
        if (t instanceof IRFunc_1.IRFunc) {
            stack.push(t.body);
            continue;
        }
        if (t instanceof IRHoisted_1.IRHoisted) {
            stack.push(t.hoisted);
            continue;
        }
    }
    return false;
}
exports.includesNode = includesNode;
